import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BoardTableModel, TaskBoardModel} from '../../../models/tasktable.model';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {CrmService} from '../../../services/api/crm.service';
import {MemberService} from '../../../services/member.service';
import {HelpersService} from '../../../services/helpers.service';
import {AlertService} from '../../../services/notify/alert.service';
import {TaskServiceService} from '../../../services/task-service.service';
import {UserTasksSettings} from '../../../models/task.model';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-board-settings-modal',
    templateUrl: './board-settings-modal.component.html',
    styleUrls: ['./board-settings-modal.component.scss']
})
export class BoardSettingsModalComponent implements OnInit {
    @Output() public emitReloading: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() public board: BoardTableModel | TaskBoardModel;

    tab: 'board_statuses' | 'board' | 'tasks_all_boards';

    optionBoard: TaskBoardModel;
    isLockButton = false;

    rangeValue: number;

    currentSettings: UserTasksSettings[] = [];

    constructor(
        protected crmService: CrmService,
        protected memberService: MemberService,
        public helper: HelpersService,
        public alert: AlertService,
        public taskService: TaskServiceService,
        private translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        const values = [280, 350, 400];

        if (this.board) {
            this.tab = 'board_statuses';

            this.selectBoard(this.board);

            if (!localStorage.getItem('board_col-size')) {
                this.rangeValue = 0;
            } else {
                const colSize = JSON.parse(localStorage.getItem('board_col-size'));
                this.rangeValue = values.indexOf(colSize[this.board.alias]) ? values.indexOf(colSize[this.board.alias]) : 0;
            }
        } else {
            this.tab = 'tasks_all_boards';
        }


        this.getSettings();
    }

    changeTab(newTab: 'board_statuses' | 'board' | 'tasks_all_boards'): void {
        if (newTab !== this.tab) {
            this.currentSettings = [];
            this.tab = newTab;
            this.getSettings();
        }
    }

    getSettings(): void {
        const alias = this.board ? this.board.alias : null;
        this.crmService.getUserStatusOrPropertiesSettings(this.tab, this.tab === 'tasks_all_boards' ? '' : alias)
            .subscribe({
                next: res => {
                    this.currentSettings = res.setting;
                }, error: err => {
                    this.alert.setAlert(err.message, 'blue');
                }
            });
    }

    updateAfterDrag(e: CdkDragDrop<Node>): void {
        moveItemInArray(this.currentSettings, e.previousIndex, e.currentIndex);
    }

    saveMemberSettings(): void {
        if (this.board) {
            const values = [280, 350, 400];
            let colSize = {};
            if (!localStorage.getItem('board_col-size')) {
                colSize[this.board.alias] = values[this.rangeValue];
                localStorage.setItem('board_col-size', JSON.stringify(colSize));
            } else {
                colSize = JSON.parse(localStorage.getItem('board_col-size'));
                colSize[this.board.alias] = values[this.rangeValue];
                localStorage.setItem('board_col-size', JSON.stringify(colSize));
            }
        }

        const settings = {
            type_setting: this.tab,
            board_alias: this.board ? this.board.alias : null,
            value: '',
        };

        settings.value = this.currentSettings.filter(x => !x.hidden).map(x => {
            if (this.tab === 'board_statuses') {
                return x.model.id;
            } else {
                return x.alias;
            }
        }).toString();

        this.isLockButton = true;
        this.crmService.setUserStatusOrPropertiesSettings(settings).subscribe({
            next: () => {
                this.isLockButton = false;
                this.alert.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'green');
                this.getSettings();
                this.emitReloading.emit(true);
            }, error: error => {
                this.isLockButton = false;
                this.alert.setAlert(error.message, 'blue');
            }
        });
    }

    changeHidden(setting: UserTasksSettings): void {
        if (setting.hidden !== false || this.currentSettings.filter(x => !x.hidden).length > 1) {
            setting.hidden = !setting.hidden;
        } else {
            this.alert.setAlert(this.translate.instant('ALERTS.HIDE_COLUMNS'), 'blue');
        }
    }

    selectBoard(board: BoardTableModel | TaskBoardModel): void {
        this.optionBoard = null;
        this.taskService.getBoard(board.alias, true).then(res => {
            this.optionBoard = res.board;
        });
    }
}
